import React from 'react';
import Modal from 'react-bootstrap/Modal';
import './PaymentFailedModal.scss';
type PaymentFailedModalProps = {
    show: boolean;
    onHide: () => void;

};

const PaymentFailedModal: React.FC<PaymentFailedModalProps> = ({ show, onHide }) => {
    return (

        <Modal className='payment-failure' show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Payment Error!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Uh oh! Your payment could not be processed at this time. In order to prevent discontinuation of service, go to the LegalSimpli account page and update your payment information. If the error persists, try using a different payment method at this secure link.</p>
                <p className='text-primary mt-4 update-info-txt' onClick={onHide}>Update Payment Info & Retry Payment Account</p>
                <p className='mt-3'>Check for common typos in the:</p>
                <ol className='mt-2'>
                    <li>Card number</li>
                    <li>Card expiration</li>
                    <li> Card security code (CVV)</li>
                    <li>  Name on card</li>
                </ol>

                Thanks in advance!
            </Modal.Body>
            <Modal.Footer>
                <button onClick={onHide} >Close</button>
            </Modal.Footer>
        </Modal >
    );
};

export default PaymentFailedModal;
